// src/components/molecules/analysis/summary-modal-content/summary-modal-content.tsx

import React, { useEffect } from 'react';
import MessageLoading from 'components/atoms/loading/message-loading';
import { useCallTranscription } from 'src/modules/shared/hooks/api/calls/call-transcription';
import TextModalContent from '../text-modal-content/text-modal-content';

interface TranscriptionModalContentProps {
  callId: number;
  enabled?: boolean;
  onCopyableContentChange?: (content: string) => void;
}

// TODO: check when implementing i18n
const DEFAULT_MESSAGE = `La transcripción puede tardar hasta 30 \
  segundos en aparecer, intentar refrescar el historial. Las llamadas perdidas \
  no generan transcripción.\
`;

const TranscriptionModalContent: React.FC<TranscriptionModalContentProps> = ({
  callId,
  enabled = true,
  onCopyableContentChange,
}) => {
  const { transcription, loading } = useCallTranscription(callId, enabled);

  useEffect(() => {
    if (!onCopyableContentChange) return;

    onCopyableContentChange(transcription?.text ?? '');
  }, [transcription, onCopyableContentChange]);

  if (loading) {
    return <MessageLoading />;
  }

  if (!transcription?.text) {
    return <TextModalContent content={DEFAULT_MESSAGE} />;
  }

  return <TextModalContent content={transcription.text} />;
};

export default TranscriptionModalContent;
